'use strict';

var endpoints = require('dibs-endpoints');

var _require = require('dibs-auth-helpers'),
    getToken = _require.getToken;

var qs = require('qs');

var _require2 = require('./util'),
    addHeaders = _require2.addHeaders,
    fetchWrapper = _require2.fetchWrapper;

function getNameAndAddress() {
    var fromOrTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof fromOrTo === 'string') {
        return {
            name: fromOrTo,
            address: fromOrTo
        };
    } else {
        var name = fromOrTo.name,
            address = fromOrTo.address;

        return {
            name: name || address,
            address: address
        };
    }
}

/**
 * Makes a call to the usercomm service to send an email via POST request.
 * @param   {String|Object}       from - Either a string address, or an object {name, address}
 * @param   {String|Object}       replyTo - Either a string address, or an object {name, address}
 * @param   {Array|String|Object} to - Same as from, except an array can be passed
 * @param   {Array|String|Object} bcc - Same as to
 * @param   {String}              subject
 * @param   {String}              body
 * @param   {String}              templateFolder - The path to the email templates
 * @param   {String}              template - The filename of the template to use
 * @param   {Object}              templateData - Any data needed to populate the template
 * @returns {Promise}             Resolved when the call completes.
 */
function sendEmail(_ref) {
    var from = _ref.from,
        replyTo = _ref.replyTo,
        to = _ref.to,
        bcc = _ref.bcc,
        subject = _ref.subject,
        body = _ref.body,
        templateFolder = _ref.templateFolder,
        template = _ref.template,
        templateData = _ref.templateData;

    var url = endpoints.sendEmailResponsys(template) + '.json?' + qs.stringify(getToken());

    var postBody = {
        folder: templateFolder,
        template: template,
        subject: subject,
        from: getNameAndAddress(from),
        replyTo: getNameAndAddress(replyTo),
        to: [].concat(to).map(getNameAndAddress),
        bcc: [].concat(bcc).map(getNameAndAddress),
        data: Object.assign({ message: body || '' }, templateData // usercomm service requires a message, even if it's blank
        ) };

    return fetchWrapper(url, addHeaders({
        method: 'POST',
        body: JSON.stringify(postBody)
    }));
}

module.exports = {
    sendEmail: sendEmail
};